export default __webpack_public_path__ + "static/media/FacebookAppIcon.9050b736.svg";